import { FileType } from '@/constants/FileTypes'
import { basePath } from '@/next.config'
import { DiscoResponse } from '@/pages/api/musicapp/_services/discoService.types'

import getRequest from './utils/getRequest'

export { clientGetSimilarTracks } from './track/getSimilarTracks'

export const clientGetTracks = async (trackIds: number[]): Promise<Track[]> => {
	const tracks = getRequest<Track[]>(
		`${basePath}/api/musicapp/music/tracks?trackIds=${trackIds}&include=royaltysplits`,
		'Tracks'
	)

	return tracks
}

export const clientGetAlbumsWithCount = async (
	page: number,
	locale: string,
	genreId?: number
): Promise<AlbumResponse> => {
	const albums = getRequest<AlbumResponse>(
		`${basePath}/api/musicapp/music/albums?page=${page}&locale=${locale}${
			genreId ? `&genre=${genreId}` : ''
		}`,
		'Albums'
	)

	return albums
}

export const clientGetStreamingServiceTrackInformation = async (
	url: string
): Promise<StreamingServiceTrackInformation> => {
	const information = getRequest<StreamingServiceTrackInformation>(
		`${basePath}/api/musicapp/streaming-services?url=${encodeURIComponent(
			url
		)}`,
		'Streaming Service Track Information'
	)

	return information
}

export const clientSearchByAudio = async (
	url: string
): Promise<AiSearchResult[]> => {
	const results = getRequest<AiSearchResult[]>(
		`${basePath}/api/musicapp/aims/url?link=${encodeURIComponent(url)}`,
		'Search By Audio'
	)

	return results
}

export const clientPromptSearch = async (
	text: string,
	length?: number
): Promise<AiSearchResult[]> => {
	const params = [`text=${encodeURIComponent(text)}`]
	if (length) {
		params.push(`length=${length}`)
	}

	const queryString = params.join('&')
	const results = await getRequest<AiSearchResult[]>(
		`${basePath}/api/musicapp/aims/prompt?${queryString}`,
		'Prompt Search'
	)

	return results || []
}

export const clientUpdateDownloadCount = async (
	tracks: Track | Track[],
	fileType: string,
	userId: number,
	organisationId: number,
	stemsTrackCount?: number
): Promise<void> => {
	const isBulkDownload = Array.isArray(tracks)
	isBulkDownload ? tracks : [tracks]

	const body = {
		TrackIds: isBulkDownload ? tracks.map((track) => track.id) : [tracks.id],
		FileType: FileType[fileType.toUpperCase()],
		OrganisationId: organisationId,
		UserId: userId,
		stemsTrackCount,
	}

	const response = await getRequest(
		`${basePath}/api/musicapp/downloads/${organisationId}`,
		'Download',
		{
			body: JSON.stringify(body),
			method: 'PATCH',
		}
	)

	// If the response is undefined, it means the request failed
	if (response === undefined) {
		throw new Error('Failed to update download count')
	}
}

export const clientSendProjectToDisco = async (
	project: Project,
	tracks: Track[]
): Promise<DiscoResponse> => {
	const result = await getRequest<DiscoResponse>(
		`${basePath}/api/musicapp/disco/playlist`,
		'Send project to DISCO',
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				Project: project,
				Tracks: tracks,
			}),
		}
	)

	return result
}

export {
	clientAddTracksToProject,
	clientDeleteCollaborator,
	clientDeleteTrackFromProject,
	clientDeleteTracksFromProject,
	clientDuplicateProject,
	clientEditProjectDetails,
	clientEditTrackNotes,
	clientProjectSimilarTracks,
	clientReorderTracksInProject,
} from './projects'
